import { useMemo, useState } from 'react';
import { NodeProps } from 'reactflow';
import styled from 'styled-components/macro';
import { ReactComponent as Water } from '../../../images/icons/water-solid.svg';
import { colourRed09, colourRed10 } from '../../../styling/colours';
import { getFlowRateString } from '../../shared/quote-or-design-form/map/map-helpers/mapHelpers';
import { PipeMapNodeData } from '../../shared/quote-or-design-form/map/mapNode';
import { PipeFields, TreeNodeType } from '../../shared/quote-or-design-form/map/treeNode';
import { MapFlowNodeReadOnly } from './MapFlowNodeReadOnly';
import { usePdfStaticReferenceData } from './usePdfStaticReferenceData';

export const ReadOnlyPipe = ({
  data: { parentTreeNode, isFirstChild, flowRateInLitresPerMinute },
}: NodeProps<PipeMapNodeData>) => {
  const [currentPipeFields, setCurrentPipeFields] = useState<PipeFields | null>(null);
  const { pipeOptions } = usePdfStaticReferenceData();

  useMemo(() => {
    setCurrentPipeFields(
      parentTreeNode.nodeType === TreeNodeType.Junction && !isFirstChild
        ? parentTreeNode.secondChild.exitPipe
        : parentTreeNode.firstChild.exitPipe,
    );
  }, [parentTreeNode, isFirstChild]);

  const flowRate = getFlowRateString(flowRateInLitresPerMinute, null);
  const pipeDisplayName = pipeOptions.find(pipe => pipe.code === currentPipeFields?.code)?.displayName;
  const title = `${currentPipeFields?.lengthInMetres}m of ${pipeDisplayName ?? ''}`;

  return (
    <PipeFlowNode
      icon={<PipeIcon />}
      stats={[title, flowRate]}
      hasSource={true}
      hasTarget={true}
      title="Pipe Section"
    />
  );
};

const PipeIcon = styled(Water)`
  height: 1em;
  width: 1em;
`;

const PipeFlowNode = styled(MapFlowNodeReadOnly)`
  border-color: ${colourRed09};
  background: ${colourRed10};
`;
